import AccidentTravailCodeRisque from '@/generated/controls/accidentTravail/AccidentTravailCodeRisque.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: AccidentTravailCodeRisque
})

